module.exports = __webpack_public_path__ + "img/pageinteriors_empresas-y-corporativos-04danos-materiales.38e4efb0.jpg";